const URLS = {
    //COMMONS

    GET_USER_PROFILE_STEPPER: '/userProfileStepper',
    GET_FAVORITE_STORES: '/FavoriteStores',
    GET_FAVORITE_FRAMES: '/FavoriteFrames',
    POST_SYNC_PURCHASES: '/SyncPurchases',

    //DASHBOARD
    GET_MY_ACCOUNT_DASHBOARD_ESPOT:
        '/wcs/resources/store/{storeId}/espot/X_MyAccountHP_Services?nocache={noCache}',
    GET_DASHBOARD_INFORMATIONS:
        '/wcs/resources/store/{storeId}/myaccount/@self/dashboard?nocache={noCache}',
    GET_MY_SAVED_ITEMS:
        '/wcs/resources/store/{storeId}/catalog/{catalogId}/saveditems/@self?pageSize=10&pageNumber=1&nocache={noCache}',
    GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT:
        '/wcs/resources/store/{storeId}/espot/X_MyAccount_HubTop_Reorder?nocache={noCache}',
    GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT:
        '/wcs/resources/store/{storeId}/espot/X_MyAccount_HubTop?nocache={noCache}',
    GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT:
        '/wcs/resources/store/{storeId}/espot/X_MyAccount_HubBottom?nocache={noCache}',

    //EYE EXAMS
    GET_USER_EYE_EXAMS:
        '/wcs/resources/store/{storeId}/eappointment/user/appointments?nocache={noCache}',
    GET_DOCTOR_INFO: '/wcs/resources/store/{storeId}/eappointment/{storeNumber}/doctors',
    DELETE_USER_EYE_EXAM:
        '/wcs/resources/store/{storeId}/eappointment/user/appointment/{appointmentId}',
    SYNC_EYE_EXAM: '/wcs/resources/store/{storeId}/myaccount/@self/synceyeexam',

    //IN-STORE SERVICES
    GET_ACCESS_TOKEN:
        '/wcs/resources/store/{storeId}/myaccountwidget/retrievejwttoken?noCache={noCache}',
    GET_PHYSICAL_STORE_INFORMATIONS:
        '/wcs/resources/store/{storeId}/storelocator/filtered/identifier/{physicalStoreId}?nocache={noCache}',

    //ONLINE ORDERS
    GET_ENCRYPTED_ONLINE_ORDER_ID: '/wcs/resources/store/{storeId}/order/crypt?nocache={noCache}',
    GET_ONLINE_ORDERS_HISTORY:
        ' /wcs/resources/store/{storeId}/order/custom/@history?responseFormat=json&pageNumber={pageNumber}&pageSize={pageSize}&currency={currency}&nocache={noCache}',
    GET_GLOBAL_ORDER_DETAILS:
        '/wcs/resources/store/{storeId}/order/custom/{orderId}?responseFormat=json&pageNumber={pageNumber}&pageSize={pageSize}&currency={currency}&profileName=IBM_Details&nocache={noCache}',
    GET_ORDER_ITEM_CARRIER_URL:
        '/wcs/resources/store/{storeId}/delivery/{orderItemId}/carrierUrl?nocache={noCache}',
    GET_ONLINE_ORDER_DETAILS_SKU_DETAILS:
        '/wcs/resources/store/{storeId}/orderitem/catentryAttributeValue/{productId}?nocache={noCache}',
    GET_RETAIL_ORDERS:
        '/wcs/resources/store/{storeId}/crm/getOrderHistory?nocache={noCache}',
    GET_PRESCRIPTION_RETAIL_ORDERS:
        '/wcs/resources/store/{storeId}/crm/getPrescriptionInfo?nocache={noCache}',  //Mandare skipCancelled a False e non True, modificare Body
    GET_PRODUCT_DETAILS: '/wcs/resources/store/{storeId}/productview/byId/{productId}',
    GET_PRESCRIPTION_VALUES: '/wcs/resources/store/{storeId}/orderitem/catentryAttributeValue/{productId}',
    //PERSONAL DETAILS
    GET_PERSONAL_DETAILS: '/wcs/resources/store/{storeId}/person/@self?nocache={noCache}',
    GET_PERSONAL_DETAILS_BAK:
        '/wcs/resources/store/{storeId}/myaccount/@self/personaldetails?nocache={noCache}',
    GET_GEOGRAPHIC_INFORMATIONS:
        'https://maps.googleapis.com/maps/api/geocode/json?address={address}&key={googleApiKey}&nocache={noCache}',
    UPDATE_PERSONAL_DETAILS: '/wcs/resources/store/{storeId}/person/@self?action=updateUserRegistration',

    //SETTINGS
    GET_USER_SETTINGS: '/wcs/resources/store/{storeId}/myaccount/@self/settings?nocache={noCache}',
    UPDATE_SETTING_PASSWORD: '/wcs/resources/store/{storeId}/myaccount/@self/resetpassword',
    UPDATE_PERSONALIZATION_SETTINGS:
        '/wcs/resources/store/{storeId}/myaccount/@self/updatepersonalizationsettings',
    CREATE_SUBSCRIPTION: '/wcs/resources/store/{storeId}/myaccount/@self/subscription/create',
    DELETE_SUBSCRIPTION: '/wcs/resources/store/{storeId}/myaccount/@self/subscription/delete',

    //MY STORES
    GET_FAVOURITES_STORES: '/wcs/resources/store/{storeId}/storelocator/@self?nocache={noCache}',
    REMOVE_FAVOURITE_STORE:
        '/wcs/resources/store/{storeId}/favouritestore/removefavourite/storelocid/{storeLocId}',
    SET_DEFAULT_STORE: '/wcs/resources/store/{storeId}/favouritestore/setdefaultstore',

    //PAYMENT METHODS
    ADD_PAYMENT_METHOD: '/wcs/resources/store/{storeId}/mypayments',
    EDIT_PAYMENT_METHOD: '/wcs/resources/store/{storeId}/mypayments/{paymentId}',
    GET_PAYMENT_METHODS: '/wcs/resources/store/{storeId}/mypayments/list?nocache={noCache}',
    SET_DEFAULT_PAYMENT_METHOD: '/wcs/resources/store/{storeId}/mypayments/setdefault/{paymentId}',
    REMOVE_PAYMENT_METHOD: '/wcs/resources/store/{storeId}/mypayments/{deletePaymentId}',

    // ADDRESSES
    GET_ADDRESSES: '/wcs/resources/store/{storeId}/person/@self/contact',
    ADD_ADDRESS: '/wcs/resources/store/{storeId}/person/@self/contact',
    SET_DEFAULT_ADDRESS: '/wcs/resources/store/{storeId}/person/@self/contact/{nickName}',
    DELETE_ADDRESS: '/wcs/resources/store/{storeId}/person/@self/contact/{nickName}',
    EDIT_ADDRESS: '/wcs/resources/store/{storeId}/person/@self/contact/{nickName}',
    REMOVE_ADDRESS: '/wcs/resources/store/{storeId}/person/@self/contact/{nickName}',
    UPDATE_ADDRESS_CST: '/wcs/resources/store/{storeId}/myaccount/updateAddress/@self',

    //PRESCRIPTION
    GET_PRESCRIPTION_INFO: '/wcs/resources/store/{storeId}/provideprescription/setup/{orderId}?rxcData=true&nocache=',
    DOWNLOAD_PRESCRIPTION: '/wcs/resources/store/{storeId}/provideprescription/download/{contextId}/{filename}',

    //DOWNLOAD RECEIPT
    DOWNLOAD_RECEIPT_METHOD: '/wcs/resources/store/{storeId}/invoice/{orderId}/download',

    //MY PRESCRIPTIONS IMPORT

    //UPLOAD FILE
    UPLOAD_PRESCRIPTION_FILE: '/wcs/resources/store/{storeId}/wcs/prescription/user/@self/upload',

    // DOWNLOAD PRESCRIPTION FILE
    DOWNLOAD_PRESCRIPTION_FILE:
        '/wcs/resources/store/{storeId}/wcs/prescription/download/{fileName}?nocache={noCache}',


    //ADD TO BAG
    ADD_TO_BAG: '/webapp/wcs/stores/servlet/OrderItemAddContactLensesCmd',
    REDIRECT_TO_CART:
        '/OrderCalculate?updatePrices=1&calculationUsageId=-1&errorViewName=AjaxOrderItemDisplayView&catalogId={catalogId}&langId={langId}&URL=AjaxOrderItemDisplayView&storeId={storeId}&orderId=.',

    //CL DETAILS
    GET_CL_DETAILS:
        '/wcs/resources/store/{storeId}/catalog/{catalogId}/contactlenses/byId/{productId}?nocache={noCache}',

    //GET_MY_SAVED_PRESCRIPTIONS: '/wcs/resources/store/{storeId}/wcs/prescription/user/@self?pageSize={pageSize}&pageNumber={pageNumber}&nocache={noCache}',
    GET_MY_SAVED_PRESCRIPTIONS:
        '/wcs/resources/store/{storeId}/wcs/prescription/user/@self?nocache={noCache}',
    REMOVE_PRESCRIPTION:
        '/wcs/resources/store/{storeId}/wcs/prescription/user/@self/{prescriptionId}',
    LOGIC_REMOVE_PRESCRIPTION:
        '/wcs/resources/store/{storeId}/crm/hideprescription/{prescriptionId}',
    GET_PD_ESPOT:
        '/wcs/resources/store/{storeId}/espot/X_HowToMeasureYourPD_Espot?nocache={noCache}',
    GET_HOW_TO_READ_ESPOT:
        '/wcs/resources/store/{storeId}/espot/D_LensPanel_HowToReadPrescription?nocache={noCache}',
    GET_HOW_TO_READ_ESPOT_CL:
        '/wcs/resources/store/{storeId}/espot/X_Understand_Prescription_Espot?nocache={noCache}',

    //ADD MY_PRESCRIPTION
    SET_MY_SAVED_PRESCRIPTION: '/wcs/resources/store/{storeId}/wcs/prescription/user/@self',
    EDIT_MY_SAVED_PRESCRIPTION:
        '/wcs/resources/store/{storeId}/wcs/prescription/user/@self/{prescriptionId}',

    //SEARCH CL
    SEARCH_CONTACT_LENSES:
        '/search/resources/store/{storeId}/productview/bySearchTerm/{searchTerm}*?searchSource=E&pageNumber=1&storeId={storeId}&profileName=RONA_CL_findProductsBySearchTerm&responseFormat=json&intentSearchTerm={searchTerm}&categoryId={categoryId}&nocache={noCache}&catalogId={catalogId}',

    //GET SKU
    GET_SKU_CL:
        '/wcs/resources/store/{storeId}/catalog/{catalogId}/contactlenses/byAttributesAndParentId/{parentProductId}',

    //SEARCH DOCTOR
    GET_DOCTOR: '/wcs/resources/store/{storeId}/provideprescription/searchdoctor/{searchTerm}',

    //DEFAULT PRESCRIPTION
    GET_DEFAULT_PRESCRIPTIONS: '/wcs/resources/store/{storeId}/crm/defaultprescription/@self?nocache={noCache}',
    SET_DEFAULT_PRESCRIPTION: '/wcs/resources/store/{storeId}/crm/defaultprescription/{action}/{categoryPrescription}/{prescriptionId}',

    //TRACK YOUR ORDER RETAIL
    TRACK_YOUR_ORDER_BY_ORDERID_AND_EMAIL: '/wcs/resources/store/{storeId}/ordersInStore/byOrderIdEmail?email={email}&orderId={orderId}',
    TRACK_YOUR_ORDER_BY_ORDERID_AND_LASTNAME: '/wcs/resources/store/{storeId}/ordersInStore/byOrderIdLastName?lastName={lastName}&orderId={orderId}',
    TRACK_YOUR_ORDER_REDIRECT_EMAIL: '/to-us/track-your-order?email={email}&orderId={orderId}',
    TRACK_YOUR_ORDER_REDIRECT_LASTNAME: '/to-us/track-your-order?lastName={lastName}&orderId={orderId}'
};

export default URLS;
